/* eslint-disable no-console */
import React, { useEffect, useRef } from 'react';
import { Mic2 } from 'lucide-react';

/**
 * GuestVideoTile — Phase 53 · Live Now guest hotfix.
 *
 * Renders ONE remote co-host inside the live stage: attaches their video
 * track to a small overlay tile and their audio track to a hidden
 * <audio autoPlay> element, so the guest is really seen AND heard by the
 * creator and by every viewer.
 */
const GuestVideoTile = ({ guest }) => {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    const v = guest.videoTrack;
    if (v && videoRef.current) {
      try {
        v.attach(videoRef.current);
        console.info('[GUEST] video attached for', guest.identity);
      } catch (e) { console.warn('[GUEST] video attach failed', e); }
    }
    return () => {
      if (v && videoRef.current) {
        try { v.detach(videoRef.current); } catch (_e) { /* noop */ }
      }
    };
  }, [guest.videoTrack, guest.identity]);

  useEffect(() => {
    const a = guest.audioTrack;
    if (a && audioRef.current) {
      try {
        a.attach(audioRef.current);
        console.info('[GUEST] audio attached for', guest.identity);
      } catch (e) { console.warn('[GUEST] audio attach failed', e); }
    }
    return () => {
      if (a && audioRef.current) {
        try { a.detach(audioRef.current); } catch (_e) { /* noop */ }
      }
    };
  }, [guest.audioTrack, guest.identity]);

  return (
    <div
      className="relative h-28 w-20 overflow-hidden rounded-lg border border-pink-500/60 bg-black shadow-lg sm:h-32 sm:w-24"
      data-testid={`guest-video-tile-${guest.identity}`}
    >
      {guest.videoTrack ? (
        <video ref={videoRef} autoPlay playsInline muted className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full items-center justify-center bg-neutral-900">
          <Mic2 className="h-6 w-6 text-pink-300" />
        </div>
      )}
      <audio ref={audioRef} autoPlay />
      <div className="absolute inset-x-0 bottom-0 truncate bg-black/60 px-1 py-0.5 text-center text-[9px] font-semibold text-white">
        @{guest.name}
      </div>
    </div>
  );
};

export default GuestVideoTile;
